import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ConfirmationModalComponent } from './confirmation/confirmation-modal.component';
import { MailingListModalComponent } from './mailinglist/mailinglist-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxEditorModule } from 'ngx-editor';

@NgModule({
  declarations: [ConfirmationModalComponent, MailingListModalComponent],
  exports: [ConfirmationModalComponent, MailingListModalComponent],
  imports: [FormsModule, CommonModule, TranslateModule],
  providers: [],
  entryComponents: [ConfirmationModalComponent, MailingListModalComponent]
})
export class ModalsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/modals/modals.module.ts